import { useState, useEffect } from "react";
import clsx from "clsx";
import { WidgetContainer } from "@/layout-components/WidgetContainer";
import { getWidgetById } from "@/utils/widgets";
import NewsquawkHeadlines from "@/widget-components/newsquawk-headlines/NewsquawkHeadlines";
import { PortfolioBuilderProvider, usePortfolioBuilder } from "./components/PortfolioBuilderContext";
import { useDensity } from "@/contexts/DensityContext";
import PortfolioBuilderBrowser from "./components/PortfolioBuilderBrowser";
import useAuth from "@/hooks/useAuth";
import DemoBanner from "@/ui-components/DemoBanner";

function PreviewInfo() {
  const { previewState, clearPreview } = usePortfolioBuilder();

  if (previewState.type === null) {
    return (
      <p className="text-xs text-gray-500 dark:text-gray-400">
        Click on any item above to preview matching headlines
      </p>
    );
  }

  return (
    <div className="flex items-center gap-2">
      <span className="text-xs text-squawk-blue">
        Previewing {previewState.type === "watchlist" ? "watchlist" : previewState.type === "tagWatchlist" ? "tag watchlist" : "filter"}
      </span>
      <button
        onClick={clearPreview}
        className="text-xs px-2 py-0.5 rounded border border-gray-300 dark:border-gray-600 bg-transparent text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200 hover:border-gray-400 dark:hover:border-gray-500 transition-colors"
      >
        Clear
      </button>
    </div>
  );
}

function WishlistAndFilterBuilder() {
  const { isCompact } = useDensity();
  const { authenticated } = useAuth();
  const [isXlScreen, setIsXlScreen] = useState(() => window.innerWidth >= 1280);

  // Track screen size
  useEffect(() => {
    const mediaQuery = window.matchMedia("(min-width: 1280px)");
    const handleChange = (e: MediaQueryListEvent) => setIsXlScreen(e.matches);
    mediaQuery.addEventListener("change", handleChange);
    return () => mediaQuery.removeEventListener("change", handleChange);
  }, []);

  const headlines = (
    <WidgetContainer
      widget={getWidgetById("NewsquawkHeadlines")!}
      onClose={() => {}}
    >
      {(headerOptions) => <NewsquawkHeadlines headerOptions={headerOptions} />}
    </WidgetContainer>
  );

  return (
    <PortfolioBuilderProvider>
      {!authenticated && <DemoBanner />}
      <div className={clsx(
        "h-screen flex flex-col overflow-hidden",
        "gap-2 p-2",
        isCompact && "gap-1 p-1",
        !authenticated && "h-[calc(100vh-42px)]"
      )}>
        {/* LibraryBrowser for all screen sizes; xl+ also gets headlines preview */}
        {!isXlScreen ? (
          <PortfolioBuilderBrowser />
        ) : (
          <>
            <PortfolioBuilderBrowser />

            {/* Bottom Section: Live Headlines Preview — xl+ only */}
            <div className="flex flex-col min-h-0 flex-1">
              <div className="px-1 pb-1 flex-shrink-0">
                <PreviewInfo />
              </div>
              <div className="flex-1 min-h-0">
                {headlines}
              </div>
            </div>
          </>
        )}
      </div>
    </PortfolioBuilderProvider>
  );
}

export default WishlistAndFilterBuilder;
